module.exports = __webpack_public_path__ + "img/empty@3x.354ef53c.png";